import {
  Button,
  Divider,
  Flex,
  HStack,
  Image,
  Link,
  Text
} from '@chakra-ui/react';
import { IoLogOutOutline } from 'react-icons/io5';

import { useAuthContext } from '../../contexts/AuthContext';
import { NotificationPopover } from '../../pages/corretor/leads/gestao/components/NotificationPopover';

export const PlatformHeader = (): JSX.Element => {
  const { logout } = useAuthContext();

  return (
    <>
      <Flex
        minH="5.6rem"
        w="100%"
        align="center"
        justify="space-between"
        p="1vw 7vw"
        bg="#FFFFFF"
        fontSize="1.5rem"
        shadow={'lg'}
      >
        <Flex>
          <Link href="/corretor">
            <HStack flexDir={{ base: 'column', md: 'row' }} spacing={2}>
              <Flex fontSize={{ base: '3vw', md: '1.5rem' }} align="center">
                <Text color="#00335E">Plataforma de</Text>
                <Text
                  bg="#00335E"
                  ml=".4rem"
                  color="gray.50"
                  p="0rem 0.6rem 0rem 0.6rem"
                  fontWeight="bold"
                  borderRadius=".25rem"
                >
                  NEGÓCIOS
                </Text>
              </Flex>
              <Divider orientation="vertical" />

              <Image src="/images/logo-sulAmerica.png" w="5rem" />
            </HStack>
          </Link>
        </Flex>
        <Link href={process.env.REACT_APP_PORTAL_URL}>
          <Button
            variant="ghost"
            aria-label="Sair"
            onClick={logout}
            leftIcon={<IoLogOutOutline />}
          >
            Sair
          </Button>
        </Link>
      </Flex>
    </>
  );
};
